import React from 'react';
import I18n from 'i18n-js';
import Text from '@/components/ui/Text';
import useFlags from '@/hooks/useFlags';
import cn from '@/utils/cn';
import { lmsProviderConfig } from '@/components/shared/Lms/lmsProviders';
import { LmsKind } from '@/components/shared/Lms/types';

interface LtiSyncInfoPanelProps {
  kind?: LmsKind | null;
}

const LtiSyncInfoPanel = ({ kind }: LtiSyncInfoPanelProps) => {
  const { updatedLtiOrphanedAssignmentFlow } = useFlags();

  if (!kind || !updatedLtiOrphanedAssignmentFlow) return null;

  return (
    <div
      className={cn(
        'tw-flex tw-mt-4 tw-p-4 tw-border tw-border-orange tw-border-solid tw-box-border',
        'tw-rounded-lg tw-bg-orange tw-bg-opacity-10',
      )}
    >
      <div className="tw-mr-3 tw-text-lg tw-text-orange tw-flex-shrink-0 tw-leading-none">
        <i className="fa fa-exclamation-triangle tw-align-middle" />
      </div>
      <div className="tw-min-w-0">
        <Text className="tw-text-black" size="sm" weight="bold">
          {I18n.t(`lti_sync_info_panel_title_${kind}`)}
        </Text>
        <Text className="tw-mt-3 tw-text-black" size="sm">
          {I18n.t(`lti_sync_info_panel_body_${kind}`)}
          <a
            className="tw-text-tci-purple tw-no-underline hover:tw-underline"
            href={lmsProviderConfig(kind).urls.syncDetails}
            rel="noopener noreferrer"
            target="_blank"
          >
            {' '}{(I18n.t('learn_more'))}
          </a>
        </Text>
      </div>
    </div>
  );
};

export default LtiSyncInfoPanel;
